import { useHead } from "@unhead/react";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { PublicFooter } from "@/components/nav/PublicFooter";
import { PublicNav } from "@/components/nav/PublicNav";
import { MainHeroBottom } from "@/components/pieces/marketing/MainHeroBottom";
import { DOMAIN, SITE_NAME } from "@/css/constants";

import { SalesCompCalculator } from "./SalesCompCalculator";

export function SalesCompPage() {
  useHead({
    bodyAttrs: { class: "public-site" },
  });

  return (
    <>
      <SEOHead
        title={`Sales Comp Calculator  ${SITE_NAME}`}
        description={`Calculate sales compensation plans with our interactive tool. Visualize ramped quotas, commission structure, accelerators, and guarantee periods to create fair and motivating sales compensation packages. Compare earnings potential
        across different scenarios with real-time projections.`}
        canonicalPath={`https://www.${DOMAIN}/sales-comp`}
        image="https://placement-pub.s3.us-east-2.amazonaws.com/sales-comp-meta.jpg"
      />
      <PublicNav fullWidth={true} />
      <SalesCompCalculator />

      <MainHeroBottom
        title="Faster Ramp, Better ROI"
        subtitle="Transform new hires into quota-crushing performers with Exec's intelligent sales simulation platform"
        ctaText="See It in Action"
        ctaLink="/demo"
      />
      <PublicFooter />
    </>
  );
}
